<div class="p-3 mb-4 bg-light rounded-3">
    <!-- Header -->
    <div class="row mb-2">
        <div class="col-12 mb-3">
            <div class="titletoptables">
                <div class="leftsideicons">
                    <img src="../../assets/image/general-setting-icon.png" alt="generalsettingicon" />
                </div>
                <h3>{{ "Maintenance" }}</h3>
            </div>
        </div>
        <div class="row position">
            <div class="col-md-12 kt-margin-bottom-20-mobile" style="display:flex; justify-content: flex-end;">
                <div class="btn-group-offer">
                    <button type="button" class="btn btn-primary addBtn" (click)="openAddDialog()">
                        Add Maintenance
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Grid -->
    <kendo-grid
        [data]="gridData"
        [pageSize]="pageSize"
        [skip]="skip"
        [pageable]="maintenanceList?.length > 0 ? pageableWithAll : false"
        (pageChange)="pageChange($event)"
        [sort]="sort"
        (sortChange)="sortChange($event)"
        [sortable]="{ mode: 'single' }"
        [resizable]="true"
        [reorderable]="true">

        <!-- Action Column -->
        <kendo-grid-column field="Action" [width]="100" title="Action" [sortable]="false" [filterable]="false" [columnMenu]="false">
            <ng-template kendoGridCellTemplate let-dataItem>
                <img *ngIf="canEdit(dataItem)"
                    alt="Edit" onkeydown="" (click)="openEditDialog(dataItem)"
                    matTooltip="Edit"
                    src="../../assets/image/edit-appointment-icon.png"
                    class="ico20 me-2" />
                <img alt="view" onkeydown="" (click)="openViewDialog(dataItem)"
                    matTooltip="View"
                    src="./assets/image/view-icon.png"
                    class="ico20 mr-2" />
            </ng-template>
        </kendo-grid-column>

        <!-- Message Column -->
        <kendo-grid-column field="MessageBox" title="Message" [width]="250">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span [title]="dataItem.MessageBox">
                    {{ dataItem.MessageBox?.length > 60 ? dataItem.MessageBox.substring(0, 60) + '...' : dataItem.MessageBox }}
                </span>
            </ng-template>
        </kendo-grid-column>

        <!-- Start Date -->
        <kendo-grid-column field="StartDate" title="Start Date" [width]="130">
            <ng-template kendoGridCellTemplate let-dataItem>
                {{ dataItem.StartDate | date:'dd/MM/yyyy' }}
            </ng-template>
        </kendo-grid-column>

        <!-- Start Time -->
        <kendo-grid-column field="StartTime" title="Start Time" [width]="110">
            <ng-template kendoGridCellTemplate let-dataItem>
                {{ formatTime(dataItem.StartTime) }}
            </ng-template>
        </kendo-grid-column>

        <!-- End Date -->
        <kendo-grid-column field="EndDate" title="End Date" [width]="130">
            <ng-template kendoGridCellTemplate let-dataItem>
                {{ dataItem.EndDate | date:'dd/MM/yyyy' }}
            </ng-template>
        </kendo-grid-column>

        <!-- End Time -->
        <kendo-grid-column field="EndTime" title="End Time" [width]="110">
            <ng-template kendoGridCellTemplate let-dataItem>
                {{ formatTime(dataItem.EndTime) }}
            </ng-template>
        </kendo-grid-column>

        <!-- Maintenance Mode Column -->
        <kendo-grid-column field="IsActiveNow" title="Maintenance Mode" [width]="150">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span [ngClass]="isActiveNow(dataItem) ? 'status-badge active' : 'status-badge inactive'">
                    {{ isActiveNow(dataItem) ? 'Active' : 'Inactive' }}
                </span>
            </ng-template>
        </kendo-grid-column>
    </kendo-grid>
</div>

<!-- Maintenance Add/View Dialog -->
<ng-template #maintenanceDialog>
    <div class="maintenance-dialog">
        <!-- Dialog Header -->
        <div class="modal-header dialog-header">
            <h4 class="popup-title">
                {{ dialogMode === 'add' ? 'Add Maintenance' : dialogMode === 'edit' ? 'Edit Maintenance' : 'Maintenance Details' }}
            </h4>
            <button type="button" class="btn-close" (click)="closeDialog()"></button>
        </div>

        <!-- Dialog Body -->
        <div class="modal-body mat-dialog-content dialog-body">

            <!-- ── VIEW MODE ── -->
            <ng-container *ngIf="dialogMode === 'view' && selectedItem">
                <div class="view-details">
                    <div class="view-row">
                        <div class="view-label">Message</div>
                        <div class="view-value message-value">{{ selectedItem.MessageBox }}</div>
                    </div>
                    <div class="view-row">
                        <div class="view-label">Start Date</div>
                        <div class="view-value">{{ selectedItem.StartDate | date:'dd/MM/yyyy' }}</div>
                    </div>
                    <div class="view-row">
                        <div class="view-label">Start Time</div>
                        <div class="view-value">{{ formatTime(selectedItem.StartTime) }}</div>
                    </div>
                    <div class="view-row">
                        <div class="view-label">End Date</div>
                        <div class="view-value">{{ selectedItem.EndDate | date:'dd/MM/yyyy' }}</div>
                    </div>
                    <div class="view-row">
                        <div class="view-label">End Time</div>
                        <div class="view-value">{{ formatTime(selectedItem.EndTime) }}</div>
                    </div>
                    <div class="view-row">
                        <div class="view-label">Maintenance Mode</div>
                        <div class="view-value">
                            <span [ngClass]="isActiveNow(selectedItem) ? 'status-badge active' : 'status-badge inactive'">
                                {{ isActiveNow(selectedItem) ? 'Active' : 'Inactive' }}
                            </span>
                        </div>
                    </div>
                </div>
            </ng-container>

            <!-- ── ADD / EDIT MODE ── -->
            <ng-container *ngIf="dialogMode === 'add' || dialogMode === 'edit'">
                <form [formGroup]="maintenanceForm" autocomplete="off">
                    <div class="row">
                        <!-- Message -->
                        <div class="col-12">
                            <mat-form-field class="w-100 custom-blue">
                                <mat-label>Message</mat-label>
                                <textarea matInput formControlName="message"
                                    placeholder="Enter maintenance message" rows="4" required></textarea>
                                <mat-error
                                    *ngIf="maintenanceForm.controls['message'].hasError('required') || maintenanceForm.get('message').errors?.['whitespace']">
                                    Message is required
                                </mat-error>
                                <mat-error
                                    *ngIf="maintenanceForm.controls['message'].value && maintenanceForm.controls['message'].value.trim().length === 0">
                                    Message cannot be empty or contain only white space.
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <!-- Start Date & Time -->
                        <div class="row mt-2">
                            <div class="col-12 col-md-6">
                                <mat-form-field class="w-100 custom-blue">
                                    <mat-label>Start Date</mat-label>
                                    <input matInput [matDatepicker]="picker1" formControlName="StartDate"
                                        [min]="isEditMode ? null : today" style="margin-top: 5px;" />
                                    <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                                    <mat-datepicker #picker1></mat-datepicker>
                                    <mat-error *ngIf="maintenanceForm.get('StartDate')?.touched && maintenanceForm.get('StartDate')?.invalid">
                                        <ng-container *ngIf="maintenanceForm.get('StartDate')?.errors?.['required']">
                                            Start date is required
                                        </ng-container>
                                        <ng-container *ngIf="maintenanceForm.get('StartDate')?.errors?.['pastDate']">
                                            Start date must be today or later
                                        </ng-container>
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="col-12 col-md-4">
                                <div class="d-flex flex-column">
                                    <label class="floating-label">Start Time</label>
                                    <kendo-timepicker [format]="'HH:mm'" formControlName="startTime"
                                        required class="w-100"></kendo-timepicker>
                                </div>
                            </div>
                        </div>

                        <!-- End Date & Time -->
                        <div class="row mt-3">
                            <div class="col-12 col-md-6">
                                <mat-form-field class="w-100 custom-blue">
                                    <mat-label>End Date</mat-label>
                                    <input matInput [matDatepicker]="picker2" formControlName="EndDate"
                                        [min]="today" style="margin-top: 5px;" />
                                    <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                                    <mat-datepicker #picker2></mat-datepicker>
                                    <mat-error *ngIf="maintenanceForm.get('EndDate')?.touched && maintenanceForm.get('EndDate')?.invalid">
                                        <ng-container *ngIf="maintenanceForm.get('EndDate')?.errors?.['required']">
                                            End date is required
                                        </ng-container>
                                        <ng-container *ngIf="maintenanceForm.get('EndDate')?.errors?.['endBeforeStart']">
                                            End date cannot be earlier than start date
                                        </ng-container>
                                        <ng-container *ngIf="maintenanceForm.get('EndDate')?.errors?.['pastDate']">
                                            End date must be today or later
                                        </ng-container>
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="col-12 col-md-4">
                                <div class="d-flex flex-column">
                                    <label class="floating-label">End Time</label>
                                    <kendo-timepicker [format]="'HH:mm'" formControlName="endTime"
                                        required class="w-100"></kendo-timepicker>
                                </div>
                            </div>
                        </div>

                        <!-- Maintenance Toggle -->
                        <div class="col-12 mt-4">
                            <div class="d-flex align-items-center gap-2">
                                <mat-label>Maintenance Mode</mat-label>
                                <mat-slide-toggle formControlName="isMaintenance"
                                    (change)="openDialogRefforactive($event)"></mat-slide-toggle>
                            </div>
                        </div>
                    </div>
                </form>
            </ng-container>
        </div>

        <!-- Dialog Footer -->
        <mat-dialog-actions align="end" class="dialog-footer">
            <button *ngIf="dialogMode === 'add' || dialogMode === 'edit'" mat-raised-button
                (click)="submit(maintenanceForm)" class="btn btn-primary me-2">
                {{ dialogMode === 'edit' ? 'Update' : 'Submit' }}
            </button>
            <button mat-raised-button (click)="closeDialog()" class="btn btn-secondary">
                Close
            </button>
        </mat-dialog-actions>
    </div>
</ng-template>
